export default __webpack_public_path__ + "static/media/collectiveRegistration.a9c122a5.jpg";